import React from 'react';

import { useAllOrders } from '~/hooks/useAllOrders';

import OrderRow from '../../../AllOrders/OrderRow';
import LiveReportList from './LiveReportList';
import { ReportProps } from './types';

export default function LiveOrders({ strategyId, from, to, setFrom, setTo }: ReportProps) {
    const { orders, loading, onEndReached } = useAllOrders(from, to, strategyId);

    return (
        <LiveReportList
            data={orders}
            loading={loading}
            onEndReached={onEndReached}
            from={from}
            to={to}
            setFrom={setFrom}
            setTo={setTo}
            renderRow={(item, isOpen) => <OrderRow order={item} isOpen={isOpen} inStrategyView />}
        />
    );
}
